import React, { ChangeEvent, useState, FormEvent, useEffect } from 'react';
import { useAppState } from '../../state';

import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Grid from '@mui/material/Grid';
// import { ReactComponent as GoogleLogo } from './google-logo.svg';
import { InputLabel } from '@mui/material';

import IntroContainer from '../IntroContainer/IntroContainer';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';

const ErrorMessage = styled(Typography)({
  color: 'red',
  display: 'flex',
  alignItems: 'center',
  margin: '1em 0 0.2em',
  '& svg': {
    marginRight: '0.4em',
  },
});

const GutterBottomTypography = styled(Typography)({
  marginBottom: '1em',
});

const PasscodeContainer = styled('div')({
  minHeight: '70px',
});

const SubmitButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export default function LoginPage() {
  const { signIn, user, isAuthReady, meetingError } = useAppState();
  const navigate = useNavigate();
  const location = useLocation();
  const [passcode, setPasscode] = useState('');
  const [meetingId, setMeetingId] = useState('');
  const [authError, setAuthError] = useState<Error | null>(null);
  const [isLogging, setIsLogging] = useState(false);

  const isAuthEnabled = Boolean(true);

  useEffect(() => {
    if (meetingError) {
      setAuthError(meetingError);
    }
  }, [meetingError])

  const login = () => {
    setAuthError(null);
    setIsLogging(true);
    signIn?.(meetingId, passcode)
      .then(() => {
        setIsLogging(false);
        // console.log("FROM", location?.state?.from);
        // navigate(location?.state?.from || { pathname: `/meeting/${meetingId}` }, { replace: true });
        navigate(`/meeting/${meetingId}`, { replace: true });
      })
      .catch(err => {
        setIsLogging(false);
        setAuthError(err);
      });
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    login();
  };

  if (user || !isAuthEnabled) {
    navigate('/', { replace: true });
  }

  if (!isAuthReady) {
    return null;
  }

  return (
    <IntroContainer>
      {/* {process.env.REACT_APP_SET_AUTH === 'firebase' && (
        <>
          <GutterBottomTypography variant="h5">
            Sign in to join a room
          </GutterBottomTypography>
          <Typography variant="body1">Sign in using your Twilio Google Account</Typography>
          <Button variant="contained" className={classes.googleButton} onClick={login} startIcon={<GoogleLogo />}>
            Sign in with Google
          </Button>
        </>
      )} */}

      {/* {process.env.REACT_APP_SET_AUTH === 'passcode' && (
        <> */}
      <GutterBottomTypography variant="h6">
        Enter details to join meeting
      </GutterBottomTypography>
      <form onSubmit={handleSubmit}>
        <Grid container justifyContent="space-between">
          <Grid size={12}>
            <PasscodeContainer>
              <InputLabel shrink htmlFor="input-meetingId">
                Meeting ID
              </InputLabel>
              <TextField
                id="input-meetingId"
                onChange={(e: ChangeEvent<HTMLInputElement>) => setMeetingId(e.target.value)}
                type="text"
                variant="outlined"
                size="small"
                fullWidth={true}
              />
            </PasscodeContainer>
          </Grid>
          <Grid size={12}>
            <PasscodeContainer>
              <InputLabel shrink htmlFor="input-passcode">
                Passcode
              </InputLabel>
              <TextField
                id="input-passcode"
                onChange={(e: ChangeEvent<HTMLInputElement>) => setPasscode(e.target.value)}
                type="password"
                variant="outlined"
                size="small"
                fullWidth={true}
              />
            </PasscodeContainer>
          </Grid>
          <div>
            {authError && (
              <ErrorMessage variant="caption">
                <ErrorOutlineIcon />
                {authError.message}
              </ErrorMessage>
            )}
          </div>
        </Grid>
        <Grid container justifyContent="flex-end">
          <SubmitButton
            variant="contained"
            color="primary"
            type="submit"
            disabled={!passcode.length || isLogging}
          >
            Submit
          </SubmitButton>
        </Grid>
      </form>
      {/* </>
      )} */}
    </IntroContainer >
  );
}
